type KrProgressBarProps = {
  count: number
  target: number
  color: string
}

const KrProgressBar = ({ count, target, color }: KrProgressBarProps) => {
  const filledPercent = target > 0 ? Math.min(100, (count / target) * 100) : 100
  return (
    <div
      role="progressbar"
      aria-label="Subscribers this quarter"
      aria-valuemin={0}
      aria-valuemax={target}
      aria-valuenow={Math.min(count, target)}
      aria-valuetext={`${count} of ${target} subscribers`}
      style={{ height: 10, borderRadius: 5, backgroundColor: '#edebe9', overflow: 'hidden' }}
    >
      <div style={{ width: `${filledPercent}%`, height: '100%', borderRadius: 5, backgroundColor: color }} />
    </div>
  )
}

export default KrProgressBar
